// TableOfContents.tsx
import React, { useEffect, useState } from "react"
import { cn } from "../lib/utils"

interface TableContentProps {
  items: Array<{ id: string; title: string; level: number }>
  className?: string
}

const TableContent: React.FC<TableContentProps> = ({ items, className }) => {
  const [activeId, setActiveId] = useState<string>("")

  useEffect(() => {
    const handleScroll = () => {
      const offsets = items.map(item => {
        const el = document.getElementById(item.id)
        if (el) {
          const rect = el.getBoundingClientRect()
          return { id: item.id, top: rect.top }
        }
        return null
      })

      const closest = offsets.filter(offset => offset && offset.top >= 0).sort((a, b) => a!.top - b!.top)[0]

      if (closest && closest.id !== activeId) {
        setActiveId(closest.id)
      }
    }

    window.addEventListener("scroll", handleScroll)
    handleScroll()

    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [items, activeId])

  return (
    <div className="flex flex-col gap-4">
      {items
        .filter(item => item.title && item.title.trim() && item.title !== "\u00A0")
        .map(item => (
          <a
            key={item.id}
            href={`#${item.id}`}
            className={cn(
              "text-base leading-6 transition-colors",
              activeId === item.id ? "text-[#0B9444]" : "text-[#4F4F4F] hover:text-[#0B9444]",
              className,
            )}
            style={{
              paddingLeft: `${(item.level - 2) * 10}px`,
            }}
            onClick={e => {
              e.preventDefault()
              const targetElement = document.getElementById(item.id)
              if (targetElement) {
                const yOffset = -90
                const yPosition = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset
                window.scrollTo({
                  top: yPosition,
                  behavior: "smooth",
                })
              }
            }}
          >
            {item.title}
          </a>
        ))}
    </div>
  )
}

export default TableContent
